import { Image, Typography } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import RocketlaneLogoSvg from 'assets/svgs/rocketlane_logo_full.svg';
import { ProductiveHeading03 } from 'components/styles';

const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: var(--spacing-08) var(--spacing-11);
`;

const Wrapper = styled.div`
  width: 520px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: var(--spacing-09);
`;

const ImageWrapper = styled.div`
  margin-bottom: var(--spacing-10);
`;

const StyledTitle = styled(Typography.Title)`
  ${ProductiveHeading03};
  font-weight: var(--heading-4-weight);
  margin: 0;
  font-size: var(--heading-3-size);
`;

export const MultipleAccounts: FC<
  React.PropsWithChildren<{
    email: string;
  }>
> = ({ email }) => {
  return (
    <Center>
      <Wrapper>
        <ItemWrapper>
          <ImageWrapper>
            <Image
              width={160}
              src={RocketlaneLogoSvg}
              alt="Rocketlane"
              preview={false}
            />
          </ImageWrapper>

          <StyledTitle>
            <FormattedMessage
              id="account_setup_multiple.accounts.header"
              values={{
                email,
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </StyledTitle>
        </ItemWrapper>
        <ItemWrapper>
          <StyledTitle>
            <FormattedMessage id="account_setup_multiple.accounts.body" />
          </StyledTitle>
        </ItemWrapper>
        <ItemWrapper>
          <FormattedMessage id="account_setup_multiple.accounts.footer" />
        </ItemWrapper>
      </Wrapper>
    </Center>
  );
};
